﻿import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  LegalOverrideDetail,
  LegalPageSlug,
  UpsertLegalOverrideRequest,
} from "@ticketnjoy/types";

import { ApiError, apiClient } from "@/lib/api-client";

export const legalOverrideQueryKey = (slug: LegalPageSlug) =>
  ["legal", "override", slug] as const;

/**
 * GET /organizer/legal/{pageSlug} → template Markdown + override (varsa).
 * TipTap editör ikisini de gösterir: override yüklenir, yoksa placeholder + template preview.
 */
export function useLegalOverrideQuery(slug: LegalPageSlug) {
  return useQuery<LegalOverrideDetail, ApiError>({
    queryKey: legalOverrideQueryKey(slug),
    queryFn: () => apiClient<LegalOverrideDetail>(`/organizer/legal/${slug}`),
    staleTime: 60 * 1000,
  });
}

/**
 * PUT /organizer/legal/{pageSlug} — override'ı upsert.
 * ContentMarkdown boşsa backend kaydı siler (template'e fallback).
 */
export function useUpsertLegalOverrideMutation(slug: LegalPageSlug) {
  const qc = useQueryClient();
  return useMutation<void, ApiError, UpsertLegalOverrideRequest>({
    mutationFn: (body) =>
      apiClient<void>(`/organizer/legal/${slug}`, {
        method: "PUT",
        body,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: legalOverrideQueryKey(slug) });
    },
  });
}
